<template>
    <div class="fill-height d-flex flex-column of-y" >
        <app-dashboard-landing ref="0" v-if="$store.state.ref.dashboard.tabIndex === 0"/>
        <app-dashboard-teams :vm="vm" ref="1" v-if="$store.state.ref.dashboard.tabIndex === 1"/>
        <app-dashboard-employees :vm="vm" ref="2" v-if="$store.state.ref.dashboard.tabIndex === 2"/>
        <app-dashboard-apps :vm="vm" ref="3" v-if="$store.state.ref.dashboard.tabIndex === 3"/>
    </div>
</template>

<script>


import AppDashboardEmployees from "@/components/Dashboard/AppDashboardEmployees";
import AppDashboardTeams from "@/components/Dashboard/AppDashboardTeams";
import AppDashboardApps from "@/components/Dashboard/AppDashboardApps";
import AppDashboardLanding from "@/components/Dashboard/AppDashboardLanding";
export default {
    components: {AppDashboardLanding, AppDashboardApps, AppDashboardTeams, AppDashboardEmployees},
    props: {
        vm: Object
    },
    data() {
        return {

        }
    },
    watch: {

    },
    computed: {

    },
}
</script>

<style scoped>

</style>